import React from 'react';
import { DESIGN_TOKENS } from '../../constants/designTokens';

const brand = DESIGN_TOKENS.brand;

export default function AppTabs({
    tabs = [],
    activeTab,
    onChange,
    className = '',
    itemClassName = '',
}) {
    return (
        <div className={`flex gap-1 p-2 bg-gray-50/50 border-b border-gray-100 overflow-x-auto no-scrollbar ${className}`.trim()}>
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    onClick={() => onChange(tab.id)}
                    className={`px-3 py-1.5 rounded-lg text-xs font-bold whitespace-nowrap transition-all ${activeTab === tab.id
                        ? `${brand.primaryBgClass} text-white shadow-sm`
                        : 'text-gray-500 hover:bg-gray-100'
                        } ${itemClassName}`.trim()}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
}
